import React, { useState } from 'react';
import { IpaType } from '../phonemes/ipa';
import { ipaToSynthSymbols } from '../speak/exact';
import { IpaChart } from './chart/IpaChart';
import { speakSegment } from './speakSegment';
import { IpaRow } from './chart/Ipa';
import { diphthongFormants, nasalFormants, rhoticFormants } from '../phonemes/formants';
import { getWithTie } from '../phonemes/getPossibleCombos';

/** show the IPA supported by eSpeak */
export function ESpeakChart() {
  const other = ['ə̆'];
  const [diphthongs] = useState(Object.getOwnPropertyNames(diphthongFormants));
  const [nasals] = useState(Object.getOwnPropertyNames(nasalFormants));
  const [rhotics] = useState(Object.getOwnPropertyNames(rhoticFormants));
  const syllabics = ['l̩', 'ɫ̩', 'm̩', 'n̩', 'ŋ̩', 'r̩'];
  const miscConsonants1 = ['kʰ', 'k˭', 'pʰ', 'p˭', 'tʰ', 'cʼ', 'kʼ', 'pʼ', 'tʼ'];
  const miscConsonants2 = ['ɥ', 'tɬ', 'dɮ', 'ᴅ', 'ɧ'];
  const clicks1 = ['ɡ͡ʘ', 'ɡ͡ǀ', 'ɡ͡ǃ', 'ɡ͡ǂ', 'ɡ͡ǁ'];
  const clicks2 = ['ŋ͡ʘ', 'ŋ͡ǀ', 'ŋ͡ǃ', 'ŋ͡ǂ', 'ŋ͡ǁ'];

  const emSpace = '\u2003';
  const lookup = (ipa: IpaType, space: IpaType): string => {
    const use = getWithTie(ipa) ?? ipa;
    const eSpeak = ipaToSynthSymbols[use];
    return eSpeak === undefined ? '-'
      : use === eSpeak ? use
        : use + space + eSpeak;
  }

  function speak(ipa: IpaType) {
    const use = getWithTie(ipa) ?? ipa;
    speakSegment(use);
  }

  const props = { lookup: (ipa: string) => lookup(ipa, emSpace), clicked: speak };

  return (<>
    <IpaChart lookup={(ipa) => lookup(ipa, ' ')} clicked={speak} br={true} />
    <table>
      <tbody>
        <IpaRow title='Others:' symbols={other} chartProps={props} />
        <IpaRow title='Diphthongs' symbols={diphthongs} chartProps={props} />
        <IpaRow title='Nasals' symbols={nasals} chartProps={props} />
        <IpaRow title='Rhotics' symbols={rhotics} chartProps={props} />
        <IpaRow title='Syllabics' symbols={syllabics} chartProps={props} />
        <IpaRow title='Consonants' symbols={miscConsonants1} chartProps={props} />
        <IpaRow title='-' symbols={miscConsonants2} chartProps={props} />
        <IpaRow title='Clicks' symbols={clicks1} chartProps={props} />
        <IpaRow title='-' symbols={clicks2} chartProps={props} />
      </tbody>
    </table>
  </>);
}
